<template>
    <div>
        <div class="mb-3">
            <label for="state" class="form-label">{{ $t('transport.field.state') }}</label>
            <select
                name="state"
                id="state"
                class="form-select"
                :class="[form.errors.state ? 'is-invalid' : '']"
                v-model="form.state"
            >
                <option value="waiting">{{ $t('transport.states.waiting') }}</option>
                <option value="cancelled">{{ $t('transport.states.cancelled') }}</option>
                <option value="finished">{{ $t('transport.states.finished') }}</option>
            </select>
            <FormError v-if="form.errors.state">
                {{ form.errors.state }}
            </FormError>
        </div>

        <div class="mb-3">
            <label for="passenger_count" class="form-label">{{ $t('transport.field.passenger_number') }}</label>
            <input
                type="number"
                name="passengerNumber"
                id="passenger_count"
                class="form-control"
                min="1"
                step="1"
                :class="[form.errors.passengerNumber ? 'is-invalid' : '']"
                v-model="form.passengerNumber"
            >
            <FormError v-if="form.errors.passengerNumber">
                {{ form.errors.passengerNumber }}
            </FormError>
        </div>

        <div class="mb-3" v-if="form.state === 'finished'">
            <label for="card_id" class="form-label">{{ $t('transport.field.car_number') }}</label>
            <input
                type="text"
                name="card_id"
                id="card_id"
                class="form-control"
                :class="[form.errors.carId ? 'is-invalid' : '']"
                v-model="form.carId"
            >
            <FormError v-if="form.errors.carId">
                {{ form.errors.carId }}
            </FormError>
        </div>

        <div class="text-end">
            <input type="button" :value="$t('transport.buttons.update')" class="btn btn-primary"  @click="updateForm"/>
        </div>
    </div>
</template>

<script>
import { useForm } from "@inertiajs/vue3";
import FormError from "../FormError.vue";

export default {
    name: "TransportUpdateForm",
    emits: ["updated"],
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: useForm({
                state: null,
                passengerNumber: null,
                carId: null,
            })
        }
    },
    methods: {
        updateForm() {
            this.form.put('/merchant/transport/'+this.item.id, {
                preserveScroll: false,
                onSuccess: () => {
                    this.$emit("updated");
                }
            })
        },
    },
    mounted() {
        this.form.state = this.item.state;
        this.form.passengerNumber = this.item.passengerNumber;
    },
    components: {
        FormError
    }
}
</script>

<style scoped>

</style>
